import '../../styles/Typography.css';

import React from 'react';

interface TypographyProps {
  children: React.ReactNode;
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'body' | 'caption';
  color?: 'primary' | 'secondary' | 'success' | 'error' | 'white';
  align?: 'left' | 'center' | 'right';
  className?: string;
}

const Typography: React.FC<TypographyProps> = ({
  children,
  variant = 'body',
  color = 'primary',
  align = 'left',
  className = '',
}) => {
  const Component = variant === 'body' || variant === 'caption' ? 'p' : variant;
  
  return (
    <Component className={`typography typography-${variant} typography-${color} typography-${align} ${className}`}>
      {children}
    </Component>
  );
};

export default Typography; 